module.exports = __webpack_public_path__ + "img/product-7-mobileINTzhuanye.ad2a5ae0.png";